import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('organizationDropdown');

    return {
        LOG_OUT: t('logout')
    };
};

export default useTranslation;
